import { Router } from '@angular/router';
import { NotificationI18nService } from '../core/util/notification-i18n.service';
import { EstadoTramite, esTramiteDadoDeBaja } from '../listado/listado-tramites-emvs/tramite-emvs';

/** Bajas visibles en el listado sin ninguna acción (inactividad, cierre de procedimiento). */
export function esTramiteBajaSoloConsulta(estadoFirma?: string): boolean {
  return estadoFirma === EstadoTramite.DADO_BAJA_AUTOMATICA
    || estadoFirma === EstadoTramite.DADO_BAJA_FIN_PROCEDIMIENTO;
}

/**
 * @returns true si el trámite está de baja y se ha bloqueado la operación
 */
export function bloquearSiTramiteDadoDeBaja(
  estadoFirma: string | undefined,
  router: Router,
  notificationI18n: NotificationI18nService,
  redirectToListado = false
): boolean {
  if (!esTramiteDadoDeBaja(estadoFirma)) {
    return false;
  }
  notificationI18n.warning('TRAMITE.ERROR.ALREADY_DEACTIVATED', 5000);
  if (redirectToListado) {
    router.navigate(['perfil'], { queryParams: { action: 30 } });
  }
  return true;
}
